<script>
export const SWITCH_TYPE = {
  primary: 'primary',
  secondary: 'secondary',
}

export default {
  name: 'BaseSwitch',
  props: {
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return Object.values(SWITCH_TYPE).includes(value)
      },
    },
  },
  computed: {
    switchClass() {
      return Object.entries({
        'tamara-base-switch': true,
        [`is-${this.type}`]: true,
      })
    },
  },
}
</script>

<template>
  <el-switch :class="switchClass" v-bind="$attrs" v-on="$listeners" />
</template>

<style lang="scss" scoped>
.tamara-base-switch {
  --tamara-switch-height: 24px;
  --tamara-switch-width: 40px;
  --tamara-switch-background-color: var(--tamara-color-background-neutral-high);

  width: 40px;
  height: 24px;

  &::v-deep {
    &.el-switch {
      &.is-checked {
        &.is-primary {
          --tamara-switch-background-color: var(--tamara-color-brand-700);
        }

        &.is-secondary {
          --tamara-switch-background-color: var(
            --tamara-color-consumer-brand-700
          );
        }

        .el-switch__core::after {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          padding-bottom: 2px;
          content: url("data:image/svg+xml,%3Csvg width='9' height='9' viewBox='0 0 9 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.75053 2.33052L3.41368 7.66842L0 4.25473L1.48842 2.76631L3.41368 4.69158L7.26211 0.842102L8.75053 2.33052Z' fill='currentColor'/%3E%3C/svg%3E%0A");
          background-color: var(--tamara-color-content-inverted);
        }
      }

      .el-switch__core {
        width: 40px !important;
        height: 24px;
        background: var(--tamara-switch-background-color);
        border: none;
        border-radius: 105px;

        // The icon inside the switch
        &::after {
          width: 18px;
          height: 18px;
          content: '';
          background-color: var(--tamara-color-content-inverted);
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
